export default {"src":"/_next/static/media/0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9.fc08aec8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};